import { atom } from "recoil"

// Save selected row ids
export const exitVoucherRowIdsState = atom({
  key: "exitVoucherRowIdsState",
  default: {},
})

// Save old package list
export const exitVoucherPackagesState = atom({
  key: "exitVoucherPackagesState",
  default: [],
})
